var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 70,
    viewBox: "0 0 80 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.4726 9H12.5274C7.53996 9 3.5 12.4242 3.5 16.6566V53.3434C3.5 57.5758 7.53996 61 12.5274 61H67.4726C72.46 61 76.5 57.5758 76.5 53.3434V16.6566C76.5 12.4242 72.46 9 67.4726 9ZM21.8215 53.2525H15.5741V48.0404H21.8215V53.2525ZM21.8215 42.8182H15.5741V37.6061H21.8215V42.8182ZM21.8215 32.3838H15.5741V27.1717H21.8215V32.3838ZM21.8215 21.9596H15.5741V16.7374H21.8215V21.9596ZM62.7863 28.2323L57.9862 32.596L62.3178 46.6364L59.8917 48.9899C59.6314 49.2424 59.1941 49.2424 58.9338 48.9899L52.4782 37.6061L46.5432 43.2828L47.4907 47.7576L45.9809 49.2222C45.7831 49.4141 45.4603 49.4141 45.2521 49.2222L36.7036 40.9192C36.5058 40.7273 36.5058 40.4141 36.7036 40.2121L38.2134 38.7475L42.7427 39.6465L48.6048 33.8586L36.9535 27.6364C36.6932 27.3737 36.6932 26.9596 36.9535 26.697L39.3795 24.3434L53.7485 28.5152L58.2778 23.8182C59.6002 22.5354 61.6826 22.4747 62.9321 23.697C64.1711 24.9293 64.1191 26.9495 62.7863 28.2323Z",
    fill: "#CDA876"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1);
export default __webpack_public_path__ + "static/media/frame_1.e1375ca8b29fdf7e148f6bf67c274dc2.svg";
export { ForwardRef as ReactComponent };